import React from 'react';
import { FormField } from '../FormField';
import { Select } from '../Select';
export const FormSelect = (props) => (React.createElement(FormField, Object.assign({ control: Select }, props)));
//# sourceMappingURL=FormSelect.js.map